<script setup lang="ts">
import { MlAlert } from 'design.zorgdomein';
import { computed } from 'vue';
import useScContext from './composables/use-sitecore-context';
import { getLocalCodeFromLang } from './utils/language';

const { language } = useScContext();
const languageCode = computed(() => getLocalCodeFromLang(language) ?? 'nl');
const message = computed(
    () =>
        ({
            en: 'You are not logged in.',
            nl: 'Je bent niet ingelogd.'
        })[languageCode.value]
);
</script>

<template>
    <div class="container">
        <MlAlert
            class="my-5"
            alert-type="warning"
            :alert-message="message"
        />
    </div>
</template>
